import { flushSync } from 'react-dom'

import { isDraftCreateNewAction } from '../../Draft.utils'

// Compares `sourceId` against the already-minimized entry (if any) to decide
// between a clean open, restore, or force-close + reopen. Plain utility so
// callers with a per-call sourceId (e.g. per-row openers) can use it
// without going through a hook.
export function resolveMinimizedDraftEntryOpen({
  action,
  entry,
  sourceId,
  onOpen,
}) {
  if (!entry || entry.sourceId !== sourceId) {
    onOpen()

    return
  }

  if (!isDraftCreateNewAction(action)) {
    entry.onRestore?.()

    return
  }

  flushSync(() => {
    entry.onForceClose?.()
  })

  onOpen()
}
